import {
  DBTC_DICP_DEPTH_ID,
  DBTC_DICP_KLINE_ID,
  DBTC_DICP_MARKET_ID,
  DBTC_DICP_TRADE_HISTORY_ID,
  DETH_DICP_DEPTH_ID,
  DETH_DICP_KLINE_ID,
  DETH_DICP_MARKET_ID,
  DETH_DICP_TRADE_HISTORY_ID,
  TOKEN_DBTC_ID,
  TOKEN_DETH_ID,
  TOKEN_DICP_ID
} from '../utils/config';

export interface MarketSetting {
  marketId: string;
  baseTokenId: string;
  quoteTokenId: string;
  priceDecimals: number;
  orderPricePrecision: number;
  orderVolumePrecision: number;
  depthVolumePrecision: number;
  depthLevels: Array<number>; //[0.0001, 0.001, 0.01, 0.1, 1.0, 10.0, 100.0]
  defaultDepthLevel: number; // depth levels index
  baseTokenPrecision: number;
  quoteTokenPrecision: number;
  feeRate: number;
  miniOrderAmount: number;
  maxBidPriceLimit: number; // 110%
  maxAskPriceLimit: number; // 90%
  depthCanisterId: string;
  tradeHistoryCanisterId: string;
  klineCanisterId: string;
}

export class Market {
  /**
   * get market setting
   * @param baseTokenId
   * @param quoteTokenId
   * @returns
   */
  public getMarketSetting = async (
    baseTokenId,
    quoteTokenId
  ): Promise<MarketSetting> => {
    if (baseTokenId === TOKEN_DBTC_ID && quoteTokenId === TOKEN_DICP_ID)
      return DBTC_DICP_MARKET_SETTING;
    else if (baseTokenId === TOKEN_DETH_ID && quoteTokenId === TOKEN_DICP_ID)
      return DETH_DICP_MARKET_SETTING;
  };

  public getMarketList = async (): Promise<Array<MarketSetting>> => {
    return [DBTC_DICP_MARKET_SETTING, DETH_DICP_MARKET_SETTING];
  };
}

const DBTC_DICP_MARKET_SETTING = {
  marketId: DBTC_DICP_MARKET_ID,
  baseTokenId: TOKEN_DBTC_ID,
  quoteTokenId: TOKEN_DICP_ID,
  priceDecimals: 32,
  orderPricePrecision: 3,
  orderVolumePrecision: 6,
  depthVolumePrecision: 6,
  depthLevels: [0.001, 0.01, 0.1, 1, 10, 100],
  defaultDepthLevel: 3,
  baseTokenPrecision: 6,
  quoteTokenPrecision: 4,
  miniOrderAmount: 10,
  feeRate: 0,
  maxBidPriceLimit: 10.0, // 1000%
  maxAskPriceLimit: 0.1, // 10%
  depthCanisterId: DBTC_DICP_DEPTH_ID,
  tradeHistoryCanisterId: DBTC_DICP_TRADE_HISTORY_ID,
  klineCanisterId: DBTC_DICP_KLINE_ID
};

const DETH_DICP_MARKET_SETTING = {
  marketId: DETH_DICP_MARKET_ID,
  baseTokenId: TOKEN_DETH_ID,
  quoteTokenId: TOKEN_DICP_ID,
  priceDecimals: 32,
  orderPricePrecision: 3,
  orderVolumePrecision: 4,
  depthVolumePrecision: 4,
  depthLevels: [0.001, 0.01, 0.1, 1, 10, 100],
  defaultDepthLevel: 3,
  baseTokenPrecision: 4,
  quoteTokenPrecision: 4,
  miniOrderAmount: 10,
  feeRate: 0,
  maxBidPriceLimit: 10.0, // 1000%
  maxAskPriceLimit: 0.1, // 10%
  depthCanisterId: DETH_DICP_DEPTH_ID,
  tradeHistoryCanisterId: DETH_DICP_TRADE_HISTORY_ID,
  klineCanisterId: DETH_DICP_KLINE_ID
};
